export default "__VITE_ASSET__ZIpGT_gh__"